// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  getRingStatistics(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestQuickGet(apiPre + service.order + '/order/screen/operatorOrderStatistics/' + params)
  },
  operatorList() {
    return http.requestQuickGet(apiPre + service.member + '/member/operator/operatorSelectionList')
  },

  getGunRealTimeStatistics(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.res + '/res/screen/gunRealTimeStatistics', params)
  },
  getOrderStatisticsV2(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.order + '/order/screen/order_statistics_v2', params)
  },
  getOperatorStationRanking(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.order + '/order/screen/operatorStationRanking', params)
  },

  getOperatorAlarm(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.ops + '/ops/screen/currentMonthAlarmStatistic', params)
  },
  getCustomerStatisticsData(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.member + '/member/screen/operatorMemberStatisticData', params)
  },
  getSixMonthChargeData(params){
    console.log('params:' + params);
    return http.requestPost(apiPre + service.order + '/order/screen/operatorSixMonthChargeData', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/monitoringCenter/api/operatingViewOperatorApi.js